// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"283":"238d979748c26f0b","335":"2bc213cb161dba84","925":"5836a4287fe78ffd"}[chunkId] + ".js";
};